import { render, staticRenderFns } from "./TestSinglePage.vue?vue&type=template&id=2fc1d24d&scoped=true&"
import script from "./TestSinglePage.vue?vue&type=script&lang=js&"
export * from "./TestSinglePage.vue?vue&type=script&lang=js&"
import style0 from "./TestSinglePage.vue?vue&type=style&index=0&id=2fc1d24d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc1d24d",
  null
  
)

export default component.exports